export const getResultCount = (state) =>
    state.result.results.maxCount;